import LoginPage from "../auth/LoginPage";
import RegisterPage from "../auth/RegisterPage";
import ForgetPassword from "../auth/ForgetPassword";
import ResetPassword from "../auth/ResetPassword";
export const authConfig = [
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/login',
        element: <RegisterPage />,
    },
    {
        path: '/forgot-password',
        element: <ForgetPassword />,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
    }
]; 